import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.SetStatus.IRequest;
type Response = Api.Core.ClaimJob.SetStatus.IResponse;
type Headers = Api.Core.ClaimJob.SetStatus.IHeaders;
const url = '/api/Claims/ClaimJob/SetStatus';
export default async function claimJobSetStatusApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
